<script>

    import FormFileMultipleInput from '../../../components/forms/FormFileMultipleInput.vue'

    export default {
        components: {
            FormFileMultipleInput
        },
        props: {
            
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        },
    }
</script>
<template>
    <div
        class="row mt-4 mb-4 gap-2"
    >
        <div class="col-12 col-sm-12 col-md-9 fs-5">
            Upload your Documents here (Maximum allowed total file size is 500MB.) 
            <a
                class="text-info"
                id="tooltip-target-1"
                style="cursor: pointer"
            >
                Supported formats?
            </a> :
            <b-tooltip
                target="tooltip-target-1"
                triggers="hover"
            >
                jpeg, png, jpg, docx, doc, pdf,
                xlsx, xlsm, xlsb, xltx, xltm, xls,
                xlt, xml, xlam, xla, xlw, xlr, prn,
                txt, csv, xlc, xld, xlk, dif, ods,
                slk, xps, dbf, pptx, pptm, ppt,
                potx, potm, pot, thmx, ppsx, ppsm,
                pps, ppam, ppa, mp4, mov, wmv, gif,
                tif, bmp, wmf, emf, rtf, odp, zip
            </b-tooltip>
        </div>
        <div class="col-12 col-sm-12 col-md-9">
            <slot />
        </div>
    </div>
</template>